export const services = [
    {
        id: 1,
        number: '01',
        header: 'Creative Developement',
        content: 'I build websites with unique and customized design.', 
        color: '#212121'
    },
    {
        id: 2,
        number: '02',
        header: 'Frontend Developement',
        content: 'I turn UI designs into websites.',
        color: '#172F44'
    },
    {
        id: 3,
        number: '03',
        header: 'Full Stack Developement',
        content: 'I build complete websites from the frontend to the backend.',
        color: '#C9473A'
    },
]